import React, { useState, useEffect } from "react";
import { endPoints } from "../../constant/Environment";
import { addData, getAllData } from "../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import EditIcon from "@mui/icons-material/Edit";

const TierMultifactor = () => {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // edit modal
  const [show, setShow] = useState(false);
  const [selectedTier, setSelectedTier] = useState("");
  const [multifactor, setMultifactor] = useState("");
  const handleClose = () => setShow(false);

  useEffect(() => {
    fetchTiers();
  }, []);

  // Loads the distinct tiers and pairs each with its current multifactor
  // (read from the exchange-rate list, since all rows in a tier share it).
  const fetchTiers = async () => {
    setIsLoading(true);
    try {
      const tiersResp = await getAllData(`${endPoints.api.GET_TIERS}`);
      const tiers = Array.isArray(tiersResp)
        ? tiersResp
        : tiersResp?.data || [];

      const ratesResp = await getAllData(`${endPoints.api.GET_EXCHANGE_RATE}`);
      const rates = Array.isArray(ratesResp)
        ? ratesResp
        : ratesResp?.data || [];

      const tierRows = tiers.map((tier) => {
        const match = rates.find((r) => r.tier === tier);
        return {
          tier,
          multifactor:
            match && match.multifactor !== undefined && match.multifactor !== null
              ? match.multifactor
              : "",
        };
      });
      setRows(tierRows);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = (row) => {
    setSelectedTier(row.tier);
    setMultifactor(
      row.multifactor !== undefined && row.multifactor !== null
        ? row.multifactor
        : ""
    );
    setShow(true);
  };

  const handleOk = () => {
    if (selectedTier && multifactor !== "") {
      let payload = {
        tier: selectedTier,
        multifactor: multifactor,
      };

      setIsLoading(true);
      addData(`${endPoints.api.UPDATE_TIER_MULTIFACTOR}`, payload)
        .then((response) => {
          setIsLoading(false);
          if (response.data.status === "success") {
            SuccesToast(response?.data?.message || "Updated Successfully");
            fetchTiers();
            handleClose();
          } else {
            ErrorToast(response?.data?.message || "Something went wrong");
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.error(error);
          ErrorToast(error);
        });
    } else {
      ErrorToast("Tier and Multifactor are required");
    }
  };

  return (
    <>
      <div className="main">
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div
                  className="col-md-12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #444",
                  }}
                >
                  <h3
                    className="mb-2 heading-table"
                    style={{ fontFamily: "ArticulatCF-Bold" }}
                  >
                    Tier Multifactor
                  </h3>
                </div>
              </div>

              <div style={{ marginTop: "10px" }}>
                <div className="row">
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        stickyHeader
                        sx={{ minWidth: 500 }}
                        aria-label="tier multifactor table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Tier</TableCell>
                            <TableCell align="center">Multifactor</TableCell>
                            <TableCell align="center">Options</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows.map((row) => (
                            <TableRow
                              key={row.tier}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell align="center">{row.tier}</TableCell>
                              <TableCell align="center">
                                {row.multifactor}
                              </TableCell>
                              <TableCell align="center">
                                <EditIcon
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleEdit(row)}
                                />
                              </TableCell>
                            </TableRow>
                          ))}

                          {rows.length === 0 && (
                            <TableRow>
                              <TableCell colSpan={3} align="center">
                                No tiers found
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>

                  {/* Edit Multifactor Modal */}
                  <Modal show={show} onHide={handleClose} size="lg">
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title-vcenter">
                        Update Multifactor — Tier {selectedTier}
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="row">
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="tier">
                            <Form.Label>Tier</Form.Label>
                            <Form.Control type="text" value={selectedTier} disabled />
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="multifactor">
                            <Form.Label>Multifactor</Form.Label>
                            <Form.Control
                              type="number"
                              placeholder="Multifactor"
                              value={multifactor}
                              onChange={(event) =>
                                setMultifactor(event.target.value)
                              }
                            />
                          </Form.Group>
                        </div>
                      </div>
                      <small style={{ color: "#888" }}>
                        This updates the multifactor for every exchange rate in
                        tier {selectedTier}.
                      </small>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        onClick={handleOk}
                        style={{
                          background: "#04631e",
                          borderColor: "#04631e",
                        }}
                      >
                        Apply
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TierMultifactor;
